import {
	Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild, ElementRef,
	ChangeDetectionStrategy, ChangeDetectorRef
} from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators, ValidatorFn } from '@angular/forms';
import { LayoutSettingsComponent } from '../layout-settings/layout-settings.component';
import { LayoutSettings } from 'DiscoveryEngine.TS/Topology';

@Component({
    selector: 'layout-settings-dialog',
	templateUrl: './layout-settings-dialog.component.html'
})
export class LayoutSettingsDialogComponent {

	@Input()
	public visible: boolean;

	@Input()
	public target: LayoutSettings;

	@Output()
	public visibleChange: EventEmitter<boolean>;

	@Output()
	public onOk: EventEmitter<any>;

	@Output()
	public onCancel: EventEmitter<any>;

    @ViewChild(LayoutSettingsComponent, { static: true })
	public layoutSettings: LayoutSettingsComponent;

	public get enableOk(): boolean {
		return true;
	}

	constructor(private changeDetector: ChangeDetectorRef) {
		this.visible = false;
		this.target = null;
		this.visibleChange = new EventEmitter<boolean>();
		this.onOk = new EventEmitter<any>();
		this.onCancel = new EventEmitter<any>();
	}

	public show(): void {
		this.visible = true;
		this.visibleChange.emit(true);

		this.changeDetector.markForCheck();
	}

	public hide(): void {
		this.visible = false;
		this.visibleChange.emit(false);

		this.changeDetector.markForCheck();
	}

	public onDialogHide(): void {
		this.hide();
		this.onCancel.emit();
	}

	public onCancelClicked(): void {
		this.layoutSettings.discardTempChanges();
		this.hide();
		this.onCancel.emit();
	}

	public onOkClicked(): void {
		this.layoutSettings.applyTempChanges();
		this.hide();
		this.onOk.emit();
	}

	public ngOnChanges(changes: SimpleChanges): void {

		if (changes["target"]) {
		}

	}

}
